import axios from "axios";
import { setUserRole, setUserUsername } from "reducers";
import { API_URL, getHeaderWithAuthorization } from "./API";
import centrifuge from "./Centrifuge";
import { TThunkDispatch } from "store";
import { removeToken } from "utils";
import { setLessons, setLoader } from "reducers";
import {
	setLectureArchive,
	setInteractiveTaskStats,
} from "pages/LectureArchive/redux";
import { setTickets } from "pages";
import { setWebinarList } from "pages/Cabinet/redux/reducer";
import {
	setCityId,
	setGroupId,
	setImport,
	setUserId,
	setUserName,
	setTrialInfo,
} from "reducers/userInfo";
import { closeModal, setNotification } from "layout";
import { setCookie } from "../utils/localStorage.util";
import { setCategories } from "../pages/Tests/redux";

export const getAuthStateV1 = async () => {
  return await axios.get(API_URL + "v1/auth/state", {
    headers: getHeaderWithAuthorization(),
  });
};

export const userLoginActionCreator = ({
  login,
  password,
  handleError,
  pushToPath,
}: {
  login: string;
  password: string;
  handleError: () => void;
  pushToPath: (path: string) => void;
}) => {
  return (dispatch: TThunkDispatch) =>
    axios
      .post(API_URL + "v1/auth/login", {
        username: login,
        password: password,
      })
      .then(({ data }) => {
        dispatch(closeModal("LoginModal"));
        setCookie("authJwt", data.token, {
          secure: true,
          "max-age": 3600 * 48,
        });
        centrifuge.setToken(data.token);
        dispatch(getUserInfoActionCreator(pushToPath));
        pushToPath("/");
      })
      .catch(() => {
        handleError();
      });
};

export const getUserInfoActionCreator = (
	pushToPath: (path: string) => void
) => {
	return (dispatch: TThunkDispatch) => {
		centrifuge.connect();
		axios
			.get(API_URL + "v2/auth/state", {
				headers: getHeaderWithAuthorization(),
			})
			.then((res) => {
				dispatch(setUserName(`${res.data.firstname} ${res.data.lastname}`));
				dispatch(setUserUsername(res.data.username));
				dispatch(setUserRole(res.data.role));
				dispatch(setUserId(res.data.id));
				dispatch(setGroupId(res.data.group_id));
				dispatch(setCityId(res.data.city_id));
				dispatch(setImport(res?.data?.import_source || null));
				// Данные пробного периода и оплаты
				dispatch(
					setTrialInfo({
						days_remaining: res?.data?.days_remaining_for_trial ?? 14,
						is_payed: res?.data?.is_payed ?? false,
						proctoring_disable: res?.data?.proctoring_disable ?? false,
						proctoring_passed: res?.data?.proctoring_passed ?? false,
						proctoring_passed_at: res?.data?.proctoring_passed_at ?? null,
						school_price: res?.data?.school_price ?? null,
					})
				);
				dispatch(getMainData());
			})
			.catch(() => {
				removeToken();
				pushToPath("/login");
			});
	};
};

export const userLogoutActionCreator = () => {
  return () => {
    centrifuge.disconnect();
    removeToken();
  };
};

export const getSchoolInfo = async (school: string) => {
  return await axios.get(`${API_URL}v2/school/${school}`, {
    headers: getHeaderWithAuthorization(),
  });
};


export const getListGroup = async () => {
  return await axios.post(`${API_URL}v2/student/groups?size=999`, {}, {
    headers: getHeaderWithAuthorization(),
  })
}

export const postStudentImport = async (data: any) => {
  return await axios.post(`${API_URL}v2/student/update`, data, {
    headers: getHeaderWithAuthorization(),
  })
}

export const getCity = async (size = 50, page = 0) => {
  return await axios.post(`${API_URL}v2/geo/cities?size=${size}&page=${page}`)
}

export const deleteTerminateSessions = () => {
  return () => {
    axios
      .delete(API_URL + "v1/auth/terminate-sessions", {
        headers: getHeaderWithAuthorization(),
      })
      .then(() => {});
  };
};

export const getLectureArchiveList = () => {
  return (dispatch: TThunkDispatch) => {
    axios
      .get(API_URL + "v1/webinar/archive", {
        headers: getHeaderWithAuthorization(),
      })
      .then((archive) => {
        dispatch(setLectureArchive(archive.data));
      });
  };
};

export const getMainData = () => {
  return (dispatch: TThunkDispatch) => {
    Promise.all([
      axios.get(API_URL + "v1/pdd-ticket/numbers-all", {
        headers: getHeaderWithAuthorization(),
      }),
      axios.get(API_URL + "v1/pdd-ticket/topics?type=all", {
        headers: getHeaderWithAuthorization(),
      }),
      axios.get(API_URL + "v1/pdd-ticket/category", {
        headers: getHeaderWithAuthorization(),
      }),
      axios.post(
        API_URL + "v2/webinar/list?size=999",
        {},
        {
          headers: getHeaderWithAuthorization(),
        }
      ),
      axios.get(API_URL + "v1/stat/interactive-task", {
        headers: getHeaderWithAuthorization(),
      }),
    ])
      .then(([numbers, topics,categories, webinars, interactiveStats]) => {
        dispatch(setTickets(numbers.data));
        dispatch(setLessons(topics.data));
        dispatch(setCategories(categories.data));
        dispatch(setInteractiveTaskStats(interactiveStats.data));
        dispatch(setWebinarList(webinars.data.items));
        dispatch(setLoader({ value: false }));
      })
      .catch((err) => {
        dispatch(
          setNotification({
            title: "Ошибка",
            message: `error code: ${err.code}, message: ${err.message}`,
            status: "error",
          })
        );
      });
  };
};

export const requestPasswordActionCreator = ({
  email,
}: {
  email: string;
}) => {
  return (dispatch: TThunkDispatch) =>
    axios
      .post(API_URL + "v2/auth/request-password", { email })
      .then(() => {
        dispatch(
          setNotification({
            title: "Готово",
            message: "Инструкция отправлена на почту",
            status: "success",
          })
        );
        dispatch(closeModal("PasswordForgotModal"));
      })
      .catch((err) => {
        let errorMessage = "Произошла ошибка при восстановлении пароля";
        
        if (err.response && err.response.data) {
          if (Array.isArray(err.response.data) && err.response.data.length > 0) {
            errorMessage = err.response.data[0].message;
          } else if (err.response.data.message) {
            errorMessage = err.response.data.message;
          }
        }
        
        dispatch(
          setNotification({
            title: "Ошибка",
            message: errorMessage,
            status: "error",
          })
        );
      });
};

// export const getMainData = () => {
//   return (dispatch: TThunkDispatch) => {
//     Promise.all([
//       axios.get(API_URL + "v1/pdd-ticket/numbers", {
//         headers: getHeaderWithAuthorization(),
//       }),
//       axios.get(API_URL + "v1/pdd-ticket/questions", {
//         headers: getHeaderWithAuthorization(),
//       }),
//       axios.get(API_URL + "v1/pdd-ticket/topics", {
//         headers: getHeaderWithAuthorization(),
//       }),
//       axios.get(API_URL + "v1/webinar/archive", {
//         headers: getHeaderWithAuthorization(),
//       }),
//       axios.get(API_URL + "v1/webinar/list", {
//         headers: getHeaderWithAuthorization(),
//       }),
//       axios.get(API_URL + "v1/stat/interactive-task", {
//         headers: getHeaderWithAuthorization(),
//       })
//     ])
//       .then(([numbers, questions, topics, archive, webinars, interactiveStats]) => {
//         dispatch(setTickets(numbers.data));
//         dispatch(setQuestions(questions.data));
//         dispatch(setLessons(topics.data));
//         dispatch(setLectureArchive(archive.data));
//         dispatch(setInteractiveTaskStats(interactiveStats.data));
//         dispatch(setWebinarList(webinars.data.list));
//         dispatch(setLoader({ value: false }));
//       })
//       .catch(console.log);
//   };
// };
